import React from 'react';
import { ReactNode, useMemo } from 'react';
import Preloader from '@web-shared/elements/Preloader';
import { AuthContext, useInitAuth } from './AuthContext';

export const SplashScreen = ({ children }: { children: ReactNode }) => {
  const { finished, user, setUser } = useInitAuth();

  const value = useMemo(() => ({
    user,
    setUser,
  }), [user]);

  return (
    <AuthContext.Provider value={value}>
      {finished ? children : <Preloader />}
    </AuthContext.Provider>
  );
};
